import { render, staticRenderFns } from "./Vouchers.vue?vue&type=template&id=4b7bc6c2"
import script from "./Vouchers.vue?vue&type=script&lang=js"
export * from "./Vouchers.vue?vue&type=script&lang=js"
import style0 from "./Vouchers.vue?vue&type=style&index=0&id=4b7bc6c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports